import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import Argon from "./plugins/argon-kit";
import './registerServiceWorker'
import VerticalTimeline from "vue-vertical-timeline";

Vue.config.productionTip = false;
Vue.use(Argon);
Vue.use(VerticalTimeline);

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
